// extracted by mini-css-extract-plugin
export default {"link":"lM-z","disabled":"mM-z"};